import { Modal } from "flowbite-react";
import { FaExclamationCircle } from "react-icons/fa";

type Props = {
  open: boolean
  onClosed: () => void;
}

export default function ModalErrorRegisterIndicator(props: Props) {
  const handleCloseModal = () => { props.onClosed && props.onClosed() }

  return (
    <Modal
      className="relative"
      show={props.open}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="text-black">

        <div className="flex items-baseline justify-center bg-gray-100">
          <span className="text-md mb-4"><FaExclamationCircle className="text-redPrimary" /></span>
          <h2 className="ml-2 text-black">Erro ao tentar realizar seu cadastro!</h2>
        </div>
      </Modal.Header>
      <Modal.Body className="dark:text-black">
        <div className="flex items-center justify-center bg-gray-100">
          <h2 className="text-2xl font-semibold mb-4"></h2>
        </div>
        <div className="flex items-center justify-center bg-gray-100">
          <span className="text-md ml-2 mb-4"> Este e-mail já está cadastrado. Por favor, verificar e tentar novamente</span>
        </div>
      </Modal.Body>
    </Modal>
  );
}